/**
 * Created by xq on 17/12/28.
 */
module.exports = function () {
  const k = 'S7QBZ-3HD37-XIEXQ-PAFUR-KZ6AF-NGFA4';// 备用：ZCSBZ-TJVKC-E552R-ALVRK-QHAOT-EZFBD
  const mapUrl = "https://map.qq.com/api/gljs?v=1.exp&libraries=service&key="+k+"&callback=onMapCallback";
  return new Promise((resolve) => {
    // 地图异步加载回调处理
    window.onMapCallback = function () {
      resolve(TMap);
    };
    let scriptLabel = document.createElement("script");
    scriptLabel.setAttribute("type", "text/javascript");
    scriptLabel.setAttribute("src", mapUrl);
    document.body.appendChild(scriptLabel);
  });
}



// WEBPACK FOOTER //
// ./src/store/TXMap.js